module.exports = __webpack_public_path__ + "static/media/Background_Modern_2x.24296df0.png";